import { IPcr } from '../../../features/pcr/store/pcr.types'
import {
  initialAddPnMedication,
  initialPnMedicationState,
} from '../../../features/procedures/pnMedication/store/pnMedication.reducers'
import {
  IAddPnMedication,
  IAddPnMedicationList,
} from '../../../features/procedures/pnMedication/store/pnMedication.types'
import Logger from '../../../services/logger.service'
import { cloneDeep } from 'lodash'

export const pnMedication = (pcr: any): IPcr => {
  const options = [
    {
      id: 8801001,
      name: 'Contraindication Noted',
      nemsisCode: 8801001,
      isNV: false,
      isPN: true,
    },
    {
      id: 8801003,
      name: 'Denied By Order',
      nemsisCode: 8801003,
      isNV: false,
      isPN: true,
    },
    {
      id: 8801007,
      name: 'Medication Allergy',
      nemsisCode: 8801007,
      isNV: false,
      isPN: true,
    },
    {
      id: 8801009,
      name: 'Medication Already Taken',
      nemsisCode: 8801009,
      isNV: false,
      isPN: true,
    },
    {
      id: 7701001,
      name: 'Not Applicable',
      nemsisCode: 7701001,
      isNV: true,
      isPN: false,
    },
    {
      id: 7701003,
      name: 'Not Recorded',
      nemsisCode: 7701003,
      isNV: true,
      isPN: false,
    },
    {
      id: 8801027,
      name: 'Order Criteria Not Met',
      nemsisCode: 8801027,
      isNV: false,
      isPN: true,
    },
    {
      id: 8801019,
      name: 'Refused',
      nemsisCode: 8801019,
      isNV: false,
      isPN: true,
    },
    {
      id: 8801023,
      name: 'Unable to Complete',
      nemsisCode: 8801023,
      isNV: false,
      isPN: true,
    },
  ]
  const getPNNVCode = (selectedValue: any) => {
    const obj = {
      id: selectedValue?.id,
      name: selectedValue?.name,
      pn: '',
      nv: '',
    }
    const option = options.find((option) => option.id === selectedValue?.id)
    if (option) {
      obj.pn = option.isPN ? String(selectedValue.id) : ''
      obj.nv = option.isNV ? String(selectedValue.id) : ''
    }
    return obj
  }

  const modifiedMedItem = (oldMed: any) => {
    const newMed: IAddPnMedication = {
      ...cloneDeep(initialAddPnMedication()),
      id: oldMed.id,
      key: oldMed.key,
      dose: oldMed.medDose,
      doseUnit: oldMed.medDoseUnit,
      route: oldMed.medRoute,
      medication: oldMed.medId,
      medicationPNNV: getPNNVCode(oldMed.value),
    }
    return newMed
  }

  const getMedicationData = (pertNegMeds: any) => {
    const updatedMedications: IAddPnMedicationList = []
    pertNegMeds.forEach((med: any) => {
      updatedMedications.push(modifiedMedItem(med))
    })
    return updatedMedications
  }

  try {
    if (!pcr.patient.medicationAdministeredStateListPNNVs && pcr.patient.patientVitals_pertNegMeds) {
      const pcrUpdated = cloneDeep(pcr)
      pcrUpdated.patient.medicationAdministeredStateListPNNVs = pcrUpdated.patient.patientVitals_pertNegMeds.map(
        (mainItem: any) => {
          const newMainItem = cloneDeep(initialPnMedicationState)
          newMainItem.key = mainItem.key
          newMainItem.date = mainItem.date
          newMainItem.time = mainItem.time
          newMainItem.pta = mainItem.pta
          newMainItem.medication = mainItem.medId
          newMainItem.medicationPNNV = getPNNVCode(mainItem.value)
          newMainItem.dose = mainItem.medDose
          newMainItem.doseUnit = mainItem.medDoseUnit
          newMainItem.route = mainItem.medRoute
          newMainItem.addToTimeline = mainItem.addToTimeline
          newMainItem.pnMedication = modifiedMedItem(mainItem.pnMedication)
          newMainItem.addMedicationAdministeredData = getMedicationData(mainItem.pertNegMeds)
          return newMainItem
        }
      )
      delete pcr.patient.patientVitals_pertNegMeds
      pcr.patient.medicationAdministeredStateListPNNVs = pcrUpdated.patient.medicationAdministeredStateListPNNVs
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule pnMedication ${error}`)
    throw error
  }
}
